var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Touchable = _interopRequireDefault(require("../Touchable"));

var _FontelloIcon = _interopRequireDefault(require("../FontelloIcon"));

var _Basic = require("../../../../elements/Basic");

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/DropDown/DropDownArrow.js";

var DropDownArrow = function DropDownArrow(_ref) {
  var disabled = _ref.disabled,
      onPress = _ref.onPress,
      invisibleStyle = _ref.invisibleStyle,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["disabled", "onPress", "invisibleStyle"]);
  return _react.default.createElement(_Touchable.default, {
    onPress: !disabled ? onPress : undefined,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.View, (0, _extends2.default)({}, rest, invisibleStyle, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 9
    }
  }), _react.default.createElement(_FontelloIcon.default, {
    center: true,
    name: "arrow-front",
    color: (0, _PropsHelper.getValueConditionally)(disabled, 'gray'),
    size: "arrowSize",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 13
    }
  })));
};

var _default = DropDownArrow;
exports.default = _default;